@if (!readOnly) {
  <ca-form-field class="full-width">
    <input
      caInput
      onLightBackground="true"
      type="text"
      [placeholder]="'insightsFilter.sitesSearchPlaceholder' | translate"
      [(ngModel)]="search"
    />
  </ca-form-field>
}
@if ((organisations | keyvalue)?.length > 0) {
  <div class="flex flex-col">
    @for (
      row of organisations
        | keyvalue
        | organisationSortPipe
        | organisationFilterPipe: search;
      track row
    ) {
      <div
        class="noSelect item"
        [class.notSelectedRow]="!selectedIds?.includes(row.key)"
        [class.selectedRow]="selectedIds?.includes(row.key)"
        [class.disabled]="disabledIds?.includes(row.key)"
        (click)="
          readOnly || disabledIds?.includes(row.key) ? null : toggle(row.value)
        "
      >
        <div class="row-content">
          <mat-checkbox
            class="noHover"
            [checked]="selectedIds?.includes(row.key)"
            [disabled]="readOnly || disabledIds?.includes(row.key)"
            [disableRipple]="true"
          ></mat-checkbox>
          <div class="avatar">
            <ca-avatar [fullName]="row.value.name" [fontSize]="11"> </ca-avatar>
          </div>
          <div class="organisation-name">
            <span class="label">{{ row.value.name }}</span>
          </div>
        </div>
      </div>
    }
  </div>
} @else {
  <p>
    {{ "organisations.select.empty" | translate }}
  </p>
}
